import L from 'leaflet'

export const MarkerIcon = new L.Icon({
    iconUrl: '/img/marker-icon.svg',
    iconRetinaUrl: '/img/marker-icon.svg',
    iconAnchor: [21,57],
    popupAnchor: null,
    shadowUrl: null,
    shadowSize: null,
    shadowAnchor: null,
    iconSize: new L.Point(60, 75),
    className: 'c-map__marker'
})

export default MarkerIcon



// WEBPACK FOOTER //
// ./src/components/MarkerIcon.js